import { render, staticRenderFns } from "./bottom-navbar.vue?vue&type=template&id=54b98538&scoped=true&"
import script from "./bottom-navbar.vue?vue&type=script&lang=js&"
export * from "./bottom-navbar.vue?vue&type=script&lang=js&"
import style0 from "./bottom-navbar.vue?vue&type=style&index=0&id=54b98538&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b98538",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomNavigation } from 'vuetify/lib/components/VBottomNavigation';
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBottomNavigation,VBtn})
